import type { GetActivitiesSectionsQuery } from '../../../lesson-builder.graphql.generated';
import { ACTIVITIES_COMPONENT_TYPE_RIVE_ANIMATION } from 'global/constants';
import { ComponentRiveAnimation } from '../../component.constants';
import { preloadFiles } from 'approot/shared/logic/preload-files';
import { getComponentsOfType } from './get-components-of-type';
import type { Pluck } from 'lib/gql/pluck';

export function preloadRiveFiles(
  section: Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections'>
) {
  const components = getComponentsOfType<ComponentRiveAnimation>({
    components: section.components,
    types: [ACTIVITIES_COMPONENT_TYPE_RIVE_ANIMATION],
  });
  const urls: string[] = [];

  components.forEach(c => {
    if (c.properties.rive.link) {
      urls.push(c.properties.rive.link);
    }
  });

  preloadFiles(urls);
}
